module.exports = __webpack_public_path__ + "img/图1-4不留装订边的图框格式.7874fbde.png";